import React from 'react';
import { Box, Typography, Paper, Divider, Chip, Button } from '@mui/material';
import { Department } from '../../types/department.types';

interface DepartmentDetailProps {
  department: Department;
  onEdit: () => void;
  onBack: () => void;
}

export const DepartmentDetail: React.FC<DepartmentDetailProps> = ({
  department,
  onEdit,
  onBack,
}) => {
  const detailItem = (label: string, value: React.ReactNode) => (
    <Box mb={2}>
      <Typography variant="subtitle2" color="textSecondary">
        {label}
      </Typography>
      <Typography variant="body1">{value || '-'}</Typography>
    </Box>
  );

  return (
    <Box>
      <Box mb={3} display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h5" component="h2">
          {department.name}
        </Typography>
        <Box>
          <Button variant="outlined" onClick={onBack} sx={{ mr: 1 }}>
            Back to List
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={onEdit}
          >
            Edit
          </Button>
        </Box>
      </Box>

      <Paper elevation={2} sx={{ p: 3 }}>
        <Box display="flex" flexWrap="wrap">
          <Box width={{ xs: '100%', md: '50%' }} pr={{ md: 2 }}>
            {detailItem('Code', department.code)}
            {detailItem('Department Type', department.deptType || '-')}
            {detailItem('Sub Type', department.subType || '-')}
          </Box>
          <Box width={{ xs: '100%', md: '50%' }} pl={{ md: 2 }}>
            {detailItem(
              'Status',
              <Chip
                label={department.status}
                color={department.isActive ? 'success' : 'default'}
                size="small"
              />
            )}
            {detailItem('Created At', new Date(department.createdAt).toLocaleString())}
            {detailItem('Last Updated', new Date(department.updatedAt).toLocaleString())}
          </Box>
        </Box>

        <Divider sx={{ my: 3 }} />

        <Box>
          <Typography variant="subtitle2" color="textSecondary" gutterBottom>
            Description
          </Typography>
          <Typography variant="body1">
            {department.description || 'No description available'}
          </Typography>
        </Box>
      </Paper>
    </Box>
  );
};
